
import React, {PureComponent, Fragment} from 'react';
import {ButtonIcon, ButtonLink, Button} from '@homeaway/react-buttons';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {SVGIcon} from '@homeaway/react-svg';
import {withTranslationsAsProps} from '../../translations';
import classnames from 'classnames';
import {withAuth} from '../../auth';
import {CHEVRON_LEFT__16} from '@homeaway/svg-defs';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';
import onboardingActions from '../actions';
import carouselSlides from '../content';
import LandingPage from '../landing-page/landing-page';
import {FormattedHTMLMessage} from 'react-intl';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import edap from '../../../tripboard/edap';

import './onboarding-carousel.less';


export const SlideBars = ({slides, imageIndex}) => {
    return (
        <div className="slide-nav__bars">
            {slides.map((_, index) => {
                return (<div key={`slide_nav_bar_${index}`} className={classnames('slide-nav__bar', {'bar--current': index === imageIndex})} />);
            })}
        </div>
    );
};

export const CTAButton = ({clickHandler, icon, label}) => {
    const buttonlabel = (<Fragment><span>{label}</span><SVGIcon inline markup={icon}/></Fragment>);
    return (
    <div className="slide-nav__button">
        <Button onClick={clickHandler} label={buttonlabel} className="btn-primary" size="sm"/>
    </div>);
};

export const SlideNavButton = ({disabled, clickHandler, pressHandler, icon, type}) => {
    return (
        <div className="slide-nav__button">
            <ButtonIcon label={''} circle svgMarkup={icon} size="sm" className={type === 'next' ? 'btn-primary' : ''} onMouseDown={pressHandler} onClick={clickHandler} disabled={disabled}/>
        </div>
    );
};

export class OnboardingCarousel extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            imageIndex: 0,
            animation: true
        };
    }

    handleNext = () => {
        this.setState({imageIndex: this.state.imageIndex + 1, animation: true});
    };

    cancelAnimation = () => {
        this.setState({animation: false});
    };

    handlePrev = () => {
        this.setState({imageIndex: this.state.imageIndex - 1, animation: true});
    };

    handleSkip = () => {
        edap.boardCreateSkip();
        this.props.completeOnboarding();
    }

    handleCreate = () => {
        edap.boardCreateClick('empty');
        this.handleComplete();
    }

    handleComplete = () => {
        this.setState({imageIndex: this.state.imageIndex + 1, animation: true});
    }

    render() {
        const {skipLabel, ctaLabel, startTripboardCreation, hav, isMobile} = this.props;
        const {imageIndex, animation} = this.state;
        const showPrevButton = imageIndex > 0;
        const showNextButton = (imageIndex + 1) < carouselSlides.length;
        const showLandingPage = imageIndex >= carouselSlides.length;
        const carouselIndex = Math.min(imageIndex, carouselSlides.length - 1);
        const carouselTitle = (carouselIndex === 1 && isMobile) ? carouselSlides[carouselIndex].mobileTitle : carouselSlides[carouselIndex].title;
        return (
            <div className="onboarding-carousel__wrapper">
                <div className="onboarding-carousel__row">
                    <div className="onboarding-carousel__nav">
                        <div className={classnames('slide-title', {'title-animation': animation})}>
                            <FormattedHTMLMessage id={carouselTitle} defaultMessage={''} description="Trip Board slide title"/>
                        </div>
                        {!showLandingPage &&
                            <div className="slide-nav">
                                <SlideNavButton disabled={!showPrevButton} clickHandler={this.handlePrev} pressHandler={this.cancelAnimation} type={'back'} icon={CHEVRON_LEFT__16} />
                                {showNextButton && <SlideBars imageIndex={carouselIndex} slides={carouselSlides} />}
                                {!showNextButton && isMobile && <SlideBars imageIndex={carouselIndex} slides={carouselSlides} />}
                                {showNextButton && <SlideNavButton clickHandler={this.handleNext} pressHandler={this.cancelAnimation} type={'next'} icon={CHEVRON_RIGHT__16} />}
                                {!showNextButton && !isMobile && <CTAButton label={ctaLabel} clickHandler={this.handleCreate} icon={CHEVRON_RIGHT__16} />}
                                {!showNextButton && isMobile && <SlideNavButton clickHandler={this.handleCreate} type={'next'} icon={CHEVRON_RIGHT__16} />}
                            </div>
                        }
                        {showLandingPage &&
                            <div className="slide-create">
                                <LandingPage startTripboardCreation={startTripboardCreation} hav={hav} isMobile={isMobile}/>
                            </div>
                        }
                    </div>
                    <div className="onboarding-carousel__slides">
                        {carouselSlides[carouselIndex].slide}
                    </div>
                </div>
                <div className="onboarding-carousel__row">
                    <div className="onboarding-carousel__skip" ><ButtonLink label={skipLabel} onClick={this.handleSkip} /></div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    completeOnboarding: onboardingActions.completeOnboarding,
    startTripboardCreation: onboardingActions.startTripboardCreation
};

const mapStateToProps = (state) => {
    return {
        onboardingCompleted: state && state.onboarding && state.onboarding.onboardingCompleted
    };
};

export default compose(withTranslationsAsProps({
    'tripboards.skip': 'skipLabel',
    'tripboards.main.empty.action': 'ctaLabel'
}), withAuth, determineIfMobile, connect(mapStateToProps, mapDispatchToProps))(OnboardingCarousel);



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/onboarding-carousel/onboarding-carousel.js